import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import * as content from './apps/content.frontend';

async function loadPolyfills() {
  if (typeof window.IntersectionObserver === 'undefined') {
    await import('intersection-observer');
  }
}

loadPolyfills();

function ready(fn) {
  if (document.readyState != 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

function onLoad() {
  const wrap = document.querySelector('.off-canvas-wrapper');

  wrap.classList.remove('hide-until-loaded');
}

ready(onLoad);

content.default();
